/** */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { addDataToStore } from 'store/actions/user-data';
import { Alert } from 'app/shared/form-alert';
import { generateUniqueId } from 'app/shared/utils/general';
import { useGuestService } from 'hooks/guest';
import styles from '../login/login.module.css';

export const OTPForm = ({ email = '' }) => {
  const dispatch = useDispatch();
  const { resendOtp, verifyOtp } = useGuestService();
  const [alert, setAlert] = useState({});
  const [form_data, setFormData] = useState({ otp: '' });
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const [user_email, setUserEmail] = useState('');

  useEffect(() => {
    setUserEmail(email);
  }, []);

  const handleOTPChange = (e) => {
    setFormData((prev) => ({ ...prev, otp: e.target.value }));
  };

  const submitForm = (e) => {
    e?.preventDefault();
    setLoading(true);
    verifyOtp(form_data.otp)
      .then((response) => {
        const { error, payload } = response;
        if (error) {
          setAlert({ message: error, id: generateUniqueId() });
          return;
        }
        dispatch(addDataToStore({ ...payload, logged_in_time: Date.now() }));
      })
      .finally(() => setLoading(false));
  };

  const handleOtpResend = () => {
    setResending(true);
    resendOtp({ data: { email: user_email } })
      .then((response) => {
        const { error, payload } = response;
        const message = error || payload?.message;
        const type = error ? 'error' : 'success';
        setAlert({ message, type, id: generateUniqueId() });
      })
      .finally(() => setResending(false));
  };

  return (
    <>
      <h1 className={styles.formHeading}>Check your email</h1>
      <p className={styles.formSubhead}>Enter the one-time password sent to your email address.</p>

      {alert.message && (
        <div className={styles.alertWrap}>
          <Alert {...alert} />
        </div>
      )}

      <form onSubmit={submitForm}>
        <div className={styles.fieldGroup}>
          <div>
            <label className={styles.fieldLabel} htmlFor="otp-input">
              One-time password
            </label>
            <input
              id="otp-input"
              type="text"
              autoFocus
              autoComplete="one-time-code"
              placeholder="Enter your OTP"
              value={form_data.otp}
              onChange={handleOTPChange}
              className={styles.input}
            />
          </div>
        </div>

        <div className={styles.resendRow}>
          <button
            type="button"
            className={styles.resendLink}
            onClick={handleOtpResend}
            disabled={resending}
          >
            {resending ? 'Resending…' : 'Resend OTP'}
          </button>
        </div>

        <button
          type="submit"
          className={styles.submitBtn}
          disabled={loading || !form_data.otp.trim()}
        >
          {loading ? 'Verifying…' : 'Verify →'}
        </button>
      </form>
    </>
  );
};
